import { useContext } from "react";
import { NavLink } from "react-router-dom";

import routes from "../../routes";
import { userRoles } from "../../shared/shared-with-mobile/constants";
import { UserContext } from "../../shared/shared-with-mobile/providers/user.provider";
import { TeamContext } from "../../shared/shared-with-mobile/providers/team.provider";
import styles from "./SideNav.module.scss";

// Vertical left-rail navigation. Replaces the in-Header NavLinks bar that
// previously stacked horizontally across the top — admins reported the
// dense top bar was hard to scan. Visibility rules match the old Nav
// component: admins see admin pages; users see coach pages once they
// have a current team.
const SideNav: React.FC = () => {
  const { userProfile } = useContext(UserContext);
  const { currentTeam } = useContext(TeamContext);

  const isAdmin = userProfile?.role === userRoles.ADMIN;
  const showNav =
    isAdmin || (userProfile?.role === userRoles.USER && currentTeam);
  if (!showNav) return null;

  const links = routes
    .filter((route) => route.display)
    .filter((route) => route.isAdmin === isAdmin);

  return (
    <nav className={styles.sideNav} aria-label="Primary navigation">
      <div className={styles.sideNav__inner}>
        {links.map((route) => (
          <NavLink
            key={route.path}
            to={route.path}
            exact={!!route.exact}
            className={styles.sideNav__link}
            activeClassName={styles.sideNav__linkActive}
          >
            {route.display}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default SideNav;
